import { render, staticRenderFns } from "./initialsBadge.vue?vue&type=template&id=11eccfe3&scoped=true"
import script from "./initialsBadge.vue?vue&type=script&lang=ts"
export * from "./initialsBadge.vue?vue&type=script&lang=ts"
import style0 from "./initialsBadge.vue?vue&type=style&index=0&id=11eccfe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eccfe3",
  null
  
)

export default component.exports